/** The connection state shown as TerminalChrome's status chip. */
export interface TerminalChromeStatus { value: string; label: string; }

export function connectionStatus(isConnected: boolean, isConnecting: boolean): TerminalChromeStatus {
    return isConnected
        ? { value: 'connected', label: 'Connected' }
        : isConnecting
            ? { value: 'running', label: 'Connecting…' }
            : { value: 'disconnected', label: 'Disconnected' };
}
